import { render, staticRenderFns } from "./kpi-mapping.vue?vue&type=template&id=528f3e4a&scoped=true"
import script from "./kpi-mapping.vue?vue&type=script&lang=ts"
export * from "./kpi-mapping.vue?vue&type=script&lang=ts"
import style0 from "./kpi-mapping.vue?vue&type=style&index=0&id=528f3e4a&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528f3e4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('528f3e4a')) {
      api.createRecord('528f3e4a', component.options)
    } else {
      api.reload('528f3e4a', component.options)
    }
    module.hot.accept("./kpi-mapping.vue?vue&type=template&id=528f3e4a&scoped=true", function () {
      api.rerender('528f3e4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/kpi-mapping/kpi-mapping.vue"
export default component.exports